webpackJsonp([1],{

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/core-js/fn/object/assign.js
var object_assign = __webpack_require__(14);
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/react-lite/dist/react-lite.common.js
var react_lite_common = __webpack_require__(1);
var react_lite_common_default = /*#__PURE__*/__webpack_require__.n(react_lite_common);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(39);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./src/styles/App.scss
var App = __webpack_require__(44);
var App_default = /*#__PURE__*/__webpack_require__.n(App);

// EXTERNAL MODULE: ./node_modules/@ta-interaktiv/parse-hostname/dist/index.js
var dist = __webpack_require__(46);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(48);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// CONCATENATED MODULE: ./src/components/main/index.js





function AppComponent() {
  var domain = Object(dist["parseHostname"])().publicationDomain;
  var search = Object(query_string["parse"])(location.search);

  switch (search['img']) {
    case 'leak':
      return react_lite_common["createElement"](
        'div',
        { className: 'index' },
        react_lite_common["createElement"]('img', { src: __webpack_require__(52), alt: 'Der Umfang der Papiere' })
      );

    case 'personen':
      return react_lite_common["createElement"](
        'div',
        { className: 'index' },
        react_lite_common["createElement"]('img', {
          src: __webpack_require__(53),
          alt: 'Die Personen, die in den Paradise Papers gefunden werden k\xF6nnen'
        }),
        react_lite_common["createElement"]('a', { id: 'ribar', href: 'https://www.' + domain + '/13540148', target: '_top' }),
        react_lite_common["createElement"]('a', {
          id: 'bastos',
          href: 'https://www.' + domain + '/22853426',
          target: '_top'
        }),
        react_lite_common["createElement"]('a', {
          id: 'glasenberg',
          href: 'https://www.' + domain + '/30374352',
          target: '_top'
        }),
        react_lite_common["createElement"]('a', { id: 'ross', href: 'https://www.' + domain + '/16948838', target: '_top' })
      );

    case 'laender':
      return react_lite_common["createElement"](
        'div',
        { className: 'index' },
        react_lite_common["createElement"]('img', {
          src: __webpack_require__(54),
          alt: 'Die L\xE4nder: mit diesen Staaten hatte Appleby am meisten Verbindugen. USA: 31180, Grossbritannien: 14434, Bermudas: 12017, Kayman-Inseln: 8640, Hongkong: 7065, China: 5924, Kanada: 3176, Isle of Man: 3054, Schweiz: 2363.'
        })
      );

    case 'vergleich':
      return react_lite_common["createElement"](
        'div',
        { className: 'index' },
        react_lite_common["createElement"]('img', { src: __webpack_require__(55), alt: 'Die Lecks im Vergleich' })
      );

    default:
      return null;
  }
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AppComponent, 'AppComponent', '/Users/km/dev/2017-11-paradise-leak-overview/src/components/main/index.js');
}();

;
// CONCATENATED MODULE: ./src/index.js






// Render the main component into the dom
react_lite_common_default.a.render(react_lite_common_default.a.createElement(
  react_hot_loader["AppContainer"],
  null,
  react_lite_common_default.a.createElement(AppComponent, null)
), document.getElementById('app'));

// Hot Module Replacement API
if (false) {
  module.hot.accept('./components/main/', function () {
    var NextApp = require('./components/main/index').default;
    ReactDOM.render(React.createElement(
      AppContainer,
      null,
      React.createElement(NextApp, null)
    ), document.getElementById('app'));
  });
}
;

var src__temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f5fb34b51392b755dd79cd62885dc889.png";

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "37d03afd9e804052db57f844548f9cac.png";

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da11b7db1557599088d4929307198fdd.png";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9b673c9dadc7a5e70838e8e358daa4cf.png";

/***/ })

},[13]);


// WEBPACK FOOTER //
// main.9998734248e18e7f94fe.js